import { useEffect, useState } from 'react'
import { getRelatedLocations } from '../api'
import { ServiceLocation } from '../typings'
import { ISearchResponse } from '@sales-center/common'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'

type State = ISearchResponse<ServiceLocation> & {
  loading: boolean
}

const initialState: State = {
  loading: false,
  count: 0,
  items: [],
  skip: 0,
  take: 0,
}

export function useGetRelatedLocationsOnMount(billToId?: string) {
  const dispatch = useAppDispatch()

  const [state, setState] = useState(() => {
    const loading = !!billToId
    return {
      ...initialState,
      loading,
    }
  })

  useEffect(() => {
    let mounted = true

    if (!!billToId) {
      const execute = async () => {
        try {
          setState((state) => ({ ...state, loading: true }))
          const result = await dispatch(getRelatedLocations(billToId))

          if (mounted) {
            if (getRelatedLocations.fulfilled.match(result)) {
              setState({
                ...result.payload,
                loading: false,
              })
            }
          }
        } catch {
          if (mounted)
            setState({
              ...initialState,
              loading: false,
            })
        }
      }
      execute()
    }

    return () => {
      mounted = false
    }
  }, [billToId, dispatch])

  return state
}
